export default __webpack_public_path__ + "static/media/035-pedestrian-1.395c97c3.png";